export default "__VITE_ASSET__C5VtDiir__"